var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNumberSquareEight = function SvgIconNumberSquareEight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.318 7.008a3.05 3.05 0 0 1 3.852.386l.005.005a3.1 3.1 0 0 1 .887 2.162v.007a3.05 3.05 0 0 1-.703 1.932l-.028.033.1.097a3.429 3.429 0 1 1-4.743-.097 3.052 3.052 0 0 1 .63-4.525m1.796 1.495a1.053 1.053 0 1 0 .948 1.057 1.1 1.1 0 0 0-.31-.756 1.05 1.05 0 0 0-.638-.301m.035 4.131a1.429 1.429 0 1 0-.279 2.844 1.429 1.429 0 0 0 .279-2.844"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 2.75A1.75 1.75 0 0 0 2.75 4.5v15c0 .966.784 1.75 1.75 1.75h15a1.75 1.75 0 0 0 1.75-1.75v-15a1.75 1.75 0 0 0-1.75-1.75zm.25 16.5V4.75h14.5v14.5z"
  }))));
};
export default SvgIconNumberSquareEight;